/* tslint:disable */
/* eslint-disable */
/**
 * Marsinet API
 * Esta API es utilizada tanto por Marsinet como por MarsiConnect. Proporciona todos los endpoints actualizados y documentación detallada, incluyendo ejemplos de datos y mocks de prueba para verificar el comportamiento de cada llamada.
 *
 * OpenAPI spec version: 5.0.1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { ColumnDto } from './column-dto';
/**
 *
 *
 * @export
 * @interface OrderByDto
 */
export interface OrderByDto {
  /**
   * Column to sort by.
   *
   * @type {Array<ColumnDto>}
   * @memberof OrderByDto
   * @example [{"table":"user","column":"created_at"}]
   */
  columns: Array<ColumnDto>;

  /**
   * Sort direction.
   *
   * @type {string}
   * @memberof OrderByDto
   * @example desc
   */
  direction: OrderByDtoDirectionEnum;
}

/**
 * @export
 * @enum {string}
 */
export enum OrderByDtoDirectionEnum {
  Asc = 'asc',
  Desc = 'desc',
}
